// Pixel text drawn straight onto a canvas (floating numbers, shop signs, labels), from the same bitmaps as the
// DEADMONTON web fonts (tools/art/fonts.py -> fontdata.ts). Crisp at whole-number scales, no font loading.
import { FONTS, type PixFont } from './fontdata';

export type FontName = 'whyte' | 'whyte-bold' | 'neon';
const glyph = (F: PixFont, c: string) => F.glyphs[c] ?? F.glyphs[c.toUpperCase()] ?? FONTS.whyte.glyphs[c] ?? F.glyphs['?'] ?? FONTS.whyte.glyphs['?'];
// punctuation a display face borrows from Whyte is drawn at a whole-pixel multiple, as in the .otf
const sub = (F: PixFont, c: string) => (F.glyphs[c] || F.glyphs[c.toUpperCase()]) ? 1 : Math.max(1, Math.round(F.px / FONTS.whyte.px));

/** height of a line in pixels at scale k (cap height plus descender) */
export const textHeight = (k = 1, font: FontName = 'whyte') => (FONTS[font].px + FONTS[font].desc) * k;

export function textWidth(text: string, k = 1, font: FontName = 'whyte'): number {
  const F = FONTS[font]; let w = 0;
  for (const c of text) { const s = sub(F, c); w += (glyph(F, c).w + F.gap) * s; }
  return Math.max(0, w - F.gap) * k;
}

/** draw text into a 2D context with its top-left at (x, y), glyph scale k; returns the width in px */
export function drawText(g: CanvasRenderingContext2D, text: string, x: number, y: number, col: string, k = 1, shadow?: string, font: FontName = 'whyte'): number {
  const F = FONTS[font];
  for (const [dx, dy, c] of (shadow ? [[k, k, shadow], [0, 0, col]] : [[0, 0, col]]) as [number, number, string][]) {
    g.fillStyle = c; let cx = x;
    for (const ch of text) {
      const G = glyph(F, ch), s = sub(F, ch) * k;
      G.rows.forEach((row, ry) => {
        let i = 0;
        while (i < row.length) {
          if (row[i] !== '#') { i++; continue; }
          let e = i; while (e < row.length && row[e] === '#') e++;
          g.fillRect(cx + i * s + dx, y + ry * s + dy, (e - i) * s, s);
          i = e;
        }
      });
      cx += (G.w + F.gap) * s;
    }
  }
  return textWidth(text, k, font);
}
